export interface QuickTipItem {
  icon: string;
  titleKey: string;
  bulletPointKeys: string[];
}

export enum QuickTipSectionType {
  GENERAL = 'general',
  LIMITATIONS = 'limitations',
  DO_MORE = 'do-more',
  CAPABILITIES = 'capabilities',
}

export interface GeneralSection {
  type: QuickTipSectionType.GENERAL;
  headingKey: string;
  items: QuickTipItem[];
}

export interface LimitationsSection {
  type: QuickTipSectionType.LIMITATIONS;
  headingKey: string;
  items: QuickTipItem[];
}

export interface DoMoreSection {
  type: QuickTipSectionType.DO_MORE;
  headingKey: string;
  bulletPointKeys: string[];
}

/** Its capability list comes from the server, which knows what the current user can actually use. */
export interface CapabilitiesSection {
  type: QuickTipSectionType.CAPABILITIES;
  headingKey: string;
}

export type QuickTipSection = GeneralSection | LimitationsSection | DoMoreSection | CapabilitiesSection;

export const QUICK_TIP_SECTIONS: QuickTipSection[] = [
  {
    type: QuickTipSectionType.CAPABILITIES,
    headingKey: 'pmwjs_ai_quick_tips_capabilities_heading',
  },
  {
    type: QuickTipSectionType.GENERAL,
    headingKey: 'pmwjs_ai_quick_tips_general_heading',
    items: [
      {
        icon: 'icon-message-prompt',
        titleKey: 'pmwjs_ai_quick_tips_get_great_results',
        bulletPointKeys: [
          'pmwjs_ai_quick_tips_get_great_results_bullet_1',
          'pmwjs_ai_quick_tips_get_great_results_bullet_2',
          'pmwjs_ai_quick_tips_get_great_results_bullet_3',
          'pmwjs_ai_quick_tips_get_great_results_bullet_4',
          'pmwjs_ai_quick_tips_get_great_results_bullet_5',
        ],
      },
      {
        icon: 'icon-ai-caption',
        titleKey: 'pmwjs_ai_quick_tips_editing_tips',
        bulletPointKeys: [
          'pmwjs_ai_quick_tips_editing_tips_bullet_1',
          'pmwjs_ai_quick_tips_editing_tips_bullet_2',
          'pmwjs_ai_quick_tips_editing_tips_bullet_3',
          'pmwjs_ai_quick_tips_editing_tips_bullet_4',
          'pmwjs_ai_quick_tips_editing_tips_bullet_5',
        ],
      },
      {
        icon: 'icon-repeat',
        titleKey: 'pmwjs_ai_quick_tips_change_style',
        bulletPointKeys: ['pmwjs_ai_quick_tips_change_style_bullet_1', 'pmwjs_ai_quick_tips_change_style_bullet_2', 'pmwjs_ai_quick_tips_change_style_bullet_3'],
      },
      {
        icon: 'icon-designs',
        titleKey: 'pmwjs_ai_quick_tips_redesign_template',
        bulletPointKeys: ['pmwjs_ai_quick_tips_redesign_template_bullet_1', 'pmwjs_ai_quick_tips_redesign_template_bullet_2', 'pmwjs_ai_quick_tips_redesign_template_bullet_3'],
      },
    ],
  },
  {
    type: QuickTipSectionType.LIMITATIONS,
    headingKey: 'pmwjs_ai_quick_tips_limitations_heading',
    items: [
      {
        icon: 'icon-text',
        titleKey: 'pmwjs_ai_quick_tips_spelling_mistakes',
        bulletPointKeys: ['pmwjs_ai_quick_tips_spelling_mistakes_bullet_1', 'pmwjs_ai_quick_tips_spelling_mistakes_bullet_2', 'pmwjs_ai_quick_tips_spelling_mistakes_bullet_3'],
      },
      {
        icon: 'icon-pencil',
        titleKey: 'pmwjs_ai_quick_tips_editing_limitations',
        bulletPointKeys: [
          'pmwjs_ai_quick_tips_editing_limitations_bullet_1',
          'pmwjs_ai_quick_tips_editing_limitations_bullet_2',
          'pmwjs_ai_quick_tips_editing_limitations_bullet_3',
          'pmwjs_ai_quick_tips_editing_limitations_bullet_4',
          'pmwjs_ai_quick_tips_editing_limitations_bullet_5',
        ],
      },
    ],
  },
  {
    type: QuickTipSectionType.DO_MORE,
    headingKey: 'pmwjs_ai_quick_tips_do_more_heading',
    bulletPointKeys: ['pmwjs_ai_quick_tips_do_more_bullet_1', 'pmwjs_ai_quick_tips_do_more_bullet_2', 'pmwjs_ai_quick_tips_do_more_bullet_3'],
  },
];
